import { render, staticRenderFns } from "./secondHalf.vue?vue&type=template&id=31d77601&"
import script from "./secondHalf.vue?vue&type=script&lang=ts&"
export * from "./secondHalf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports